import { useApiClient } from '@brewardapp/api-client';
import { Badge } from '@breward/ui';
import { validate as validateUUID } from 'uuid';

export const DescriptorBadge = ({ value }: { value: string }) => {
    const api = useApiClient();
    const isUUID = validateUUID(value);

    const { data: descriptorData, isLoading } = api.descriptors.useFindDescriptor(
        {
            filter: {
                id: value,
            },
        },
        {
            enabled: isUUID,
        },
    );

    if (isLoading) {
        return (
            <Badge
                label={
                    <div className="flex items-center gap-1">
                        <div className="icon-[ph--spinner] h-3 w-3 animate-spin" />
                        <span>Loading...</span>
                    </div>
                }
                type="primary"
                className="text-xs"
            />
        );
    }

    const displayName = isUUID ? ((descriptorData as any)?.data?.name || 'Unknown descriptor') : value;

    return (
        <Badge
            label={displayName}
            type="primary"
            className="text-xs"
        />
    );
};
